var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tooltip',{attrs:{"label":_vm.$t(_vm.params.tooltipKey),"append-to-body":""}},[_c('div',{staticClass:"icon-header"},[_c('icon',{attrs:{"icon":_vm.params.icon,"size":_vm.IconSize.XS}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }